// extracted by mini-css-extract-plugin
module.exports = {"stepsWrapper":"FinishedAuctionsSteps_stepsWrapper__I3Qf7","stepsWrapperWinner":"FinishedAuctionsSteps_stepsWrapperWinner__8PyTr"};